import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import FormControl from 'react-bootstrap/lib/FormControl';

import t from '../../../lib/I18n';

import Icon from '../../general/Icon';

export const hours = _.range(0, 24);

const changeHandler = (callback) => (e) => callback(parseInt(e.target.value, 10));

function HourSelector ({ hour, onChange, disabled, min, max }) {
    const uniqueId = _.uniqueId('hour__selector_');
    return (
        <div className="hours select-container">
            <Icon icon="dropdown" />

            <label htmlFor={ uniqueId } className="sr-only">
                { t('booking.time.labels.hours') }
            </label>

            <FormControl
                componentClass="select"
                disabled={ disabled }
                name="hours"
                id={ uniqueId }
                className="hours__form-control"
                value={ hour }
                onChange={ changeHandler(onChange) }
            >
                {hours.map(num =>
                    <option
                        key={ num }
                        value={ num }
                        disabled={ num > max || num < min }
                    >
                        { _.padStart(num, 2, '0') }
                    </option>
                )}
            </FormControl>
        </div>
    );
}

HourSelector.propTypes = {
    hour: PropTypes.oneOf(hours),
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    min: PropTypes.oneOf(hours),
    max: PropTypes.oneOf(hours)
};

HourSelector.defaultProps = {
    hour: 12,
    onChange: _.noop,
    disabled: false,
    min: 0,
    max: 23
};

export default HourSelector;
